export const styles = {
  sectionContainer: (theme) => ({
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    flexWrap: { lg: "nowrap", xs: "wrap" },
    gap: 4,
    bgcolor: "#f8f8f8",
  }),
  container: (theme) => ({}),
};
